module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-persoonlijk-voornaamwoord.json
// module id = 1305
// module chunks = 208790847847745